import { IFinancialCockpitEltDocument } from '../../api/types'

export const sortEltDocuments = (
  documents: IFinancialCockpitEltDocument[]
): IFinancialCockpitEltDocument[] =>
  [...documents].sort(
    (a, b) => b.FYear - a.FYear || b.FQuarter - a.FQuarter || b.Version - a.Version
  )
